export function getFeatures() {
  try {
    const raw = sessionStorage.getItem('authUser');
    if (!raw) return null;
    const features = JSON.parse(raw).features;
    return Array.isArray(features) ? features : null;
  } catch {
    return null;
  }
}

// Returns true if the tenant has the given feature, or if no feature list is set (backward compat).
export function hasFeature(key) {
  const features = getFeatures();
  if (features === null) return true;
  return features.includes(key);
}
